import { BrandfolderHexColors } from '../enums/colors.js';

const defaultOptionDark = {
    backgroundColor: '#333',
    backgroundColorHover: BrandfolderHexColors.Text,
    backgroundColorSelected: BrandfolderHexColors.GrayDark,
    textColor: BrandfolderHexColors.White,
    textColorDisabled: '#BCBCBC'
};
const defaultOptionLight = {
    backgroundColor: BrandfolderHexColors.White,
    backgroundColorHover: BrandfolderHexColors.DirtyMarshmallowHalf,
    backgroundColorSelected: BrandfolderHexColors.DirtyMarshmallow,
    textColor: BrandfolderHexColors.Text,
    textColorDisabled: BrandfolderHexColors.GrayMedium
};

export { defaultOptionDark, defaultOptionLight };
//# sourceMappingURL=option.js.map
